import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { formatDateInIsrael } from '../utils/dateUtils';
import './UsersManagementPage.css';

function UsersManagementPage() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    role: 'user'
  });
  const [submitLoading, setSubmitLoading] = useState(false);

  // בדוק אם המשתמש הוא אדמין
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.role !== 'admin') {
      navigate('/books');
    }
  }, [navigate]);

  // טען את רשימת המשתמשים
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/auth/users');
      setUsers(response.data);
      setError('');
    } catch (err) {
      console.error('Error fetching users:', err);
      setError('שגיאה בטעינת משתמשים');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    
    if (!formData.username || !formData.email || !formData.password) {
      setError('כל השדות הם חובה');
      return;
    }

    if (formData.password.length < 6) {
      setError('הסיסמה חייבת להיות לפחות 6 תווים');
      return;
    }

    try {
      setSubmitLoading(true);
      await api.post('/auth/register', {
        username: formData.username,
        email: formData.email,
        password: formData.password,
        role: formData.role
      });

      setFormData({ username: '', email: '', password: '', role: 'user' });
      setShowAddForm(false);
      setError('');
      await fetchUsers();
      alert('משתמש נוצר בהצלחה!');
    } catch (err) {
      setError(err.response?.data?.error || 'שגיאה ביצירת משתמש');
    } finally {
      setSubmitLoading(false);
    }
  };

  if (loading) {
    return <div style={{ padding: '20px' }}>טוען משתמשים...</div>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <h2>ניהול משתמשים</h2>

      {error && (
        <div style={{
          backgroundColor: '#f8d7da',
          color: '#721c24',
          padding: '12px',
          borderRadius: '4px',
          marginBottom: '20px'
        }}>
          {error}
        </div>
      )}

      <button
        onClick={() => setShowAddForm(!showAddForm)}
        className="btn btn-primary"
        style={{ marginBottom: '20px' }}
      >
        {showAddForm ? '❌ ביטול' : '➕ הוסף משתמש'}
      </button>

      {showAddForm && (
        <form onSubmit={handleAddUser} style={{
          backgroundColor: '#f8f9fa',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '20px',
          maxWidth: '500px'
        }}>
          <div style={{ marginBottom: '15px' }}>
            <label>שם משתמש</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleInputChange}
              className="form-control"
              disabled={submitLoading}
            />
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label>דוא"ל</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="form-control"
              disabled={submitLoading}
            />
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label>סיסמה</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className="form-control"
              disabled={submitLoading}
            />
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label>תפקיד</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleInputChange}
              className="form-control"
              disabled={submitLoading}
            >
              <option value="user">משתמש רגיל</option>
              <option value="admin">מנהל</option>
            </select>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={submitLoading}
            style={{ width: '100%' }}
          >
            {submitLoading ? 'יוצר...' : 'צור משתמש'}
          </button>
        </form>
      )}

      <div style={{
        overflowX: 'auto',
        marginTop: '20px'
      }}>
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          border: '1px solid #ddd'
        }}>
          <thead style={{ backgroundColor: '#f8f9fa' }}>
            <tr>
              <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #ddd' }}>שם משתמש</th>
              <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #ddd' }}>דוא"ל</th>
              <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #ddd' }}>תפקיד</th>
              <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #ddd' }}>תאריך יצירה</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="4" style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                  אין משתמשים
                </td>
              </tr>
            ) : (
              users.map(user => (
                <tr key={user.id} style={{ borderBottom: '1px solid #ddd' }}>
                  <td style={{ padding: '12px' }}>{user.username}</td>
                  <td style={{ padding: '12px' }}>{user.email}</td>
                  <td style={{ padding: '12px' }}>
                    <span style={{
                      display: 'inline-block',
                      padding: '4px 12px',
                      borderRadius: '12px',
                      backgroundColor: user.role === 'admin' ? '#d4edda' : '#e7e7ff',
                      color: user.role === 'admin' ? '#155724' : '#004085'
                    }}>
                      {user.role === 'admin' ? 'מנהל' : 'משתמש רגיל'}
                    </span>
                  </td>
                  <td style={{ padding: '12px' }}>
                    {formatDateInIsrael(user.created_at)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UsersManagementPage;
